import { render, staticRenderFns } from "./EditTriggerModal.vue?vue&type=template&id=4bbf9fe7&scoped=true"
import script from "./EditTriggerModal.vue?vue&type=script&lang=js"
export * from "./EditTriggerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf9fe7",
  null
  
)

export default component.exports